import React from 'react';
import { Label } from '@mentimeter/slides-presentation-ui/title/label';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';
import type { MiroStaticContent } from '@core-api/presentation/types/response';
import {
  usePresentationContext,
  usePresentationSlideContext,
} from '../../legacy-context/presentationContext';
import { Miro } from './Miro';

const DEFAULT_BOARD_ID = `uXjVMkSiW1M=`;
const DEFAULT_BOARD_URL = `https://miro.com/app/board/${DEFAULT_BOARD_ID}`;

export function MiroPresentation() {
  const { useConfig } = usePresentationContext();

  const slide = usePresentationSlideContext();
  const staticContent = slide.staticContent as MiroStaticContent;

  const { mode } = useConfig();
  const miroUrl = staticContent.url || DEFAULT_BOARD_URL;

  return (
    <Box width="100%" height="100%" alignItems="center" justifyContent="center">
      <Miro url={miroUrl} isScreenshotMode={mode === 'screenshot'} />
      <Box mb={4} /> {/* Spacer */}
      {staticContent.label && (
        <Label>
          <MarkdownText
            disableLineBreaks
            source={staticContent.label}
            allowHyperlinks
          />
        </Label>
      )}
      {slide.title && (
        <Text
          textAlign="center"
          fontSize={8}
          fontWeight="semiBold"
          color="text"
          mb={2}
          fontFamily="heading"
          data-testid="question-title"
        >
          {slide.title}
        </Text>
      )}
      {staticContent.additionalDetails && (
        <Text textAlign="center" fontSize={4}>
          {staticContent.additionalDetails}
        </Text>
      )}
    </Box>
  );
}
